import { axios } from '@/utils/request'
export function getMasterDepositList (parameter) {
  return axios({
    url: '/master/bondApply/masterBondList',
    method: 'get',
    params: parameter
  })
}
export function getagreementConfirmList (parameter) {
  return axios({
    url: '/order/comSign/getConfirmUserList',
    method: 'get',
    params: parameter
  })
}
